
export enum PayOffOptionsEnum {
  PAY_FULL = 'payFull',
  PAY_AT_PROPERTY = 'payAtProperty',
  PAY_PARTIALLY = 'payPartially',
};

export type PayOffOptions = {
  [PayOffOptionsEnum.PAY_FULL]: boolean;
  [PayOffOptionsEnum.PAY_AT_PROPERTY]: boolean;
  [PayOffOptionsEnum.PAY_PARTIALLY]: boolean;
};

export enum PaymentMethodOptionsEnum {
  CARD = 'card',
  PAYPAL = 'paypal'
}

export type PaymentMethodOptions = {
  [PaymentMethodOptionsEnum.CARD]: boolean;
  [PaymentMethodOptionsEnum.PAYPAL]: boolean;
};

export enum BookingStepsLabels {
  STEP_1 = '1. Choose how to pay',
  STEP_2 = '2. Choose payment method',
  STEP_3 = '3. Details',
}